// CourseCard.js
import React from 'react';
import { Card, Typography } from 'antd';
import PlayButton from './PalyButton';
import CardFooter from './CardFooter';
import CardTitle from './CardTitle';
import CoverImage from './CoverImage';

const CourseCard = ({
  title,
  imageUrl,
  count,
  completionPercentage,
  onPlayButtonClick,
  cardType,
  module,
  isAssessment
}: any) => {
  return (
    <div className="course-card" onClick={() => onPlayButtonClick(module)}>
      <CoverImage imageUrl={imageUrl} />
      <CardFooter
        cardType={cardType}
        count={count}
        completionPercentage={completionPercentage}
        isAssessment={isAssessment}
      />
      <PlayButton cardType={cardType} />
      <CardTitle title={title} />
    </div>
  );
};

export default CourseCard;
